// Duits (de-DE), languagesApp: zelfde vorm als languagesApp.nl.ts. Wat ontbreekt valt terug op
// het Nederlands (nooit een rauwe sleutel op het scherm).
export const appLanguagesDe = {
    title: 'Sprache',
    settingsBody: 'In welcher Sprache ihr die App, die Tablets und die E-Mails seht',
    welcomeTitle: 'Willkommen. Welche Sprache sprecht ihr zu Hause?',
    welcomeBody: 'Wähle die Sprache eurer Familie. Du kannst das später jederzeit in den Einstellungen ändern.',
    continue: 'Weiter',
    household: 'Sprache der Familie',
    householdHint: 'Für die App, die Tablets und die E-Mails. Jedes Familienmitglied und jedes Tablet folgt dieser Sprache, außer du wählst etwas anderes.',
    saved: 'Sprache gespeichert',
    partial: 'Noch ist nicht alles übersetzt. Was noch fehlt, erscheint auf Niederländisch.',
    digitsTitle: 'Ziffern',
    digitsLatin: 'Normale Ziffern',
    digitsArabic: 'Arabische Ziffern',
    digitsHint: 'Für Uhrzeiten und Zahlen, auf den Tablets und in der App.',
    overridesTitle: 'Eine eigene Sprache',
    overridesBody: 'Spricht jemand lieber eine andere Sprache, oder steht ein Tablet in einem Zimmer? Das wählst du unter Familie und Tablets.',
    overridesOff: 'Eine eigene Sprache pro Person oder Tablet ist ausgeschaltet. Du schaltest sie unter Module ein.',
    toMembers: 'Zu Familie',
    toDevices: 'Zu Tablets',
    sameAsFamily: 'Wie die Familie ({language})',
    memberLabel: 'Sprache',
    memberHint: 'Für die App und die E-Mails von {name}.',
    deviceLabel: 'Sprache dieses Tablets',
    deviceHint: 'Praktisch für ein Tablet im Kinderzimmer. Sonst folgt es der Familie.',
    deviceSaved: '{name} spricht jetzt {language}',
    ownLanguage: 'Spricht {language}',
    authLabel: 'Sprache',
};
//# sourceMappingURL=languagesApp.de.js.map